import { computed, inject, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CmsModulePositionComponent } from '@common/cms/frontend-shared';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import { UiInputTextareaComponent } from '@common/ui/frontend-shared/input-textarea';
import { BeginDemoRequest, CheckDemoExtensionStatusRequest, CompanyClientStatus, CompanyDemoHelper, DemoExtensionStatus, ExtendDemoRequest } from '@common/users/shared';
import { AccessFacade, AccessState, AppRequestService, LocalMessageHandlerService, ReplaceableComponentDirective } from "@core/frontend-shared";
import { ConfigService } from "@core/shared/config";
import { RouterLinkResolverService } from '@core/shared/feature';
import { Store } from '@ngxs/store';
import { filter, take } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@ngxs/store";
import * as i3 from "@angular/router";
import * as i4 from "@core/shared/feature";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
import * as i7 from "../../../../../ui/frontend-shared/src/lib/card/card";
import * as i8 from "../../../../../ui/frontend-shared/src/lib/button/button";
const _c0 = () => ({});
const _c1 = a0 => ({
  onComplete: a0
});
const _c2 = (a0, a1) => ({
  id: "users-demo-subscribe",
  inputs: a0,
  outputs: a1
});
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "Ein Antrag auf Verl\u00E4ngerung ist leider nicht m\u00F6glich.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, "Bitte wenden Sie sich ggf. an den Support, um die individuelle Situation zu kl\u00E4ren.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ui-card", 3);
    i0.ɵɵelement(7, "cms-module-position", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 5);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_1_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.viewOverride.set(null));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const state_r3 = i0.ɵɵnextContext(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Ihre Testphase wurde bereits ", state_r3.extensions, " mal verl\u00E4ngert.");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("context", ctx_r1.moduleContext);
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Wir bitten um kurzes Feedback, warum eine Demoverl\u00E4ngerung ben\u00F6tigt wird. Vielen Dank!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "ui-input-textarea", 6);
    i0.ɵɵlistener("ngModelChange", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template_ui_input_textarea_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.feedback.set($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ui-input-group")(4, "button", 7);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.submitExtensionInquiry());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 5);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.viewOverride.set(null));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r1.feedback());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("loading", ctx_r1.busy());
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵconditionalCreate(1, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_1_Template, 9, 2);
    i0.ɵɵconditionalCreate(2, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Conditional_2_Template, 6, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const state_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.extensions >= 2 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.extensions < 2 ? 2 : -1);
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Wir freuen uns sehr, Sie als Kunden begr\u00FC\u00DFen zu d\u00FCrfen!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Bitte senden Sie uns Ihre Vertrags- und Rechnungsanschrift an ", ctx_r1.contactMail, ". Unsere Mitarbeiter schalten den Account Ihres Unternehmens umgehend f\u00FCr die dauerhafte Nutzung frei. ");
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_2_ng_container_1_Template, 5, 1, "ng-container", 8);
    i0.ɵɵelementStart(2, "button", 5);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_2_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.viewOverride.set(null));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("replaceableComponent", i0.ɵɵpureFunction2(4, _c2, i0.ɵɵpureFunction0(1, _c0), i0.ɵɵpureFunction1(2, _c1, ctx_r1.onCompleteSubscribe)));
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "h3");
    i0.ɵɵtext(2, "Vielen Dank f\u00FCr Ihre Anmeldung!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, "Unser Supportteam bearbeitet derzeit Ihre Daten und schaltet Ihren Account frei.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Sobald dies geschehen ist, erhalten Sie von uns eine Information per Mail!");
    i0.ɵɵelementEnd()();
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "p");
    i0.ɵɵtext(2, "Ihr Antrag auf Verl\u00E4ngerung Ihrer Demo wird derzeit gepr\u00FCft.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, "Dies dauert in der Regel nur ein paar Minuten.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "app-messages");
    i0.ɵɵelementStart(6, "button", 9);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_4_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.refreshStatus());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("loading", ctx_r1.busy());
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "p");
    i0.ɵɵtext(2, "Ihr Antrag auf Verl\u00E4ngerung Ihrer Demo wurde leider abgelehnt.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, "Bitte wenden Sie sich an den Support, um individuelle Optionen zu erfragen.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ui-card", 3);
    i0.ɵɵelement(6, "cms-module-position", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 10);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_5_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.viewOverride.set("subscribe"));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("context", ctx_r1.moduleContext);
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "p");
    i0.ɵɵtext(2, "Ihr Antrag auf Verl\u00E4ngerung wurde angenommen.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 11);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_6_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.refreshAndOpenManagement());
    });
    i0.ɵɵelementEnd()();
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onClickExtend());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("loading", ctx_r1.busy());
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.viewOverride.set("extend"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("loading", ctx_r1.busy());
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 12)(2, "h2", 13);
    i0.ɵɵelement(3, "ui-icon", 14);
    i0.ɵɵtext(4, " Ihre Testphase ist abgelaufen. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Was m\u00F6chten Sie tun?");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 15)(8, "ui-input-group");
    i0.ɵɵconditionalCreate(9, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Conditional_9_Template, 1, 1, "button", 16);
    i0.ɵɵconditionalCreate(10, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Conditional_10_Template, 1, 1, "button", 17);
    i0.ɵɵelementStart(11, "button", 10);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.viewOverride.set("subscribe"));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const state_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵconditional(state_r3.extensions === 0 ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.extensions >= 1 ? 10 : -1);
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 12)(2, "h2", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, "Sie starten nun in Ihre komplett kostenfreie 14-t\u00E4gige Testphase. Nach Ablauf der Testphase fragen wir Sie, wie es weitergehen soll.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 15)(7, "button", 11);
    i0.ɵɵlistener("click", function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_8_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClickStart());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Herzlich willkommen bei ", ctx_r1.platformName, "!");
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵconditionalCreate(1, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_1_Template, 3, 2, "div", 2);
    i0.ɵɵconditionalCreate(2, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_2_Template, 3, 7, "div", 2);
    i0.ɵɵconditionalCreate(3, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_3_Template, 7, 0, "div", 2);
    i0.ɵɵconditionalCreate(4, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_4_Template, 7, 1, "div", 2);
    i0.ɵɵconditionalCreate(5, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_5_Template, 8, 1, "div", 2);
    i0.ɵɵconditionalCreate(6, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_6_Template, 4, 0, "div", 2);
    i0.ɵɵconditionalCreate(7, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_7_Template, 12, 2, "div", 2);
    i0.ɵɵconditionalCreate(8, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Conditional_8_Template, 8, 1, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const state_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "extend" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "subscribe" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "contract-pending" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "extension-pending" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "extension-rejected" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "extension-granted" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "expired" ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(state_r3.showDialog === "start" ? 8 : -1);
  }
}
function UsersDemoStartOverlayComponent_Conditional_0_ng_template_1_Template(rf, ctx) {}
function UsersDemoStartOverlayComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UsersDemoStartOverlayComponent_Conditional_0_Conditional_0_Template, 9, 8, "div", 1);
    i0.ɵɵtemplate(1, UsersDemoStartOverlayComponent_Conditional_0_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.showDialog ? 0 : -1);
  }
}
export let UsersDemoStartOverlayComponent = /*#__PURE__*/(() => {
  class UsersDemoStartOverlayComponent {
    constructor(api, store, access, router, resolver) {
      this.api = api;
      this.store = store;
      this.access = access;
      this.router = router;
      this.resolver = resolver;
      this.config = inject(ConfigService);
      this.msg = inject(LocalMessageHandlerService);
      this.demo = inject(Store).selectSignal(AccessState.accessData('demo'));
      this.company = inject(Store).selectSignal(AccessState.accessData('company'));
      this.contactMail = this.config.get('contact.mail');
      this.platformName = this.config.get('pagetitle');
      this.moduleContext = {
        contactEmail: this.config.get('contact.mail', null),
        contactPhone: this.config.get('contact.phone', null),
        businessHours: this.config.get('contact.businessHours', null)
      };
      this.feedback = signal('', ...(ngDevMode ? [{
        debugName: "feedback"
      }] : /* istanbul ignore next */[]));
      this.viewOverride = signal(null, ...(ngDevMode ? [{
        debugName: "viewOverride"
      }] : /* istanbul ignore next */[]));
      this.busy = signal(false, ...(ngDevMode ? [{
        debugName: "busy"
      }] : /* istanbul ignore next */[]));
      this.status = computed(() => {
        const clientStatus = this.company()?.clientStatus;
        if (!this.company() || clientStatus === CompanyClientStatus.Contracted) {
          return {
            hasDemo: false,
            showDialog: false
          };
        }
        const demo = this.demo();
        if (!demo) return {
          hasDemo: false,
          showDialog: null
        };
        const dialog = this.viewOverride() || this.getDialogToDisplay(demo, clientStatus);
        return {
          hasDemo: true,
          pendingContract: clientStatus === CompanyClientStatus.Pending,
          started: !!demo.startDate,
          extensions: demo.extensions,
          showDialog: dialog,
          expired: CompanyDemoHelper.isDemoExpired(demo)
        };
      }, ...(ngDevMode ? [{
        debugName: "status"
      }] : /* istanbul ignore next */[]));
      this.onCompleteSubscribe = () => {
        this.refreshSession().subscribe(() => {
          this.viewOverride.set('contract-pending');
        });
      };
    }
    getDialogToDisplay(demo, clientStatus) {
      if (!demo) {
        if (clientStatus === CompanyClientStatus.Pending) return 'contract-pending';else return null;
      } else if (demo.extensionStatus === DemoExtensionStatus.Pending) {
        return 'extension-pending';
      } else if (demo.extensionStatus === DemoExtensionStatus.Rejected) {
        return 'extension-rejected';
      } else if (CompanyDemoHelper.isDemoExpired(demo)) {
        return 'expired';
      } else if (!demo.startDate) {
        return 'start';
      } else {
        return null;
      }
    }
    onClickStart() {
      const companyId = this.company().id;
      this.store.selectSnapshot(AccessState.accessData);
      this.busy.set(true);
      this.api.sendRequest(BeginDemoRequest, {
        companyId
      }).subscribe(response => {
        this.refreshAndOpenManagement();
      });
    }
    refreshAndOpenManagement() {
      this.refreshSession().subscribe(() => {
        this.busy.set(false);
        this.viewOverride.set(null);
        const link = this.resolver.resolveRouterLink('frontend', 'management');
        this.router.navigate(link);
      });
    }
    refreshSession() {
      this.access.refreshSession();
      return this.store.select(AccessState.loggedIn).pipe(filter(loggedIn => loggedIn), take(1));
    }
    onClickExtend() {
      if (this.demo().extensions > 0) throw new Error('one-click extension not allowed');
      this.busy.set(true);
      const companyId = this.company().id;
      this.api.sendRequest(ExtendDemoRequest, {
        companyId
      }).subscribe(response => {
        this.handleExtensionInquiryResponse(response);
      });
    }
    submitExtensionInquiry() {
      const feedback = this.feedback();
      if (feedback.length < 7) {
        this.msg.create("Bitte erläutern Sie uns kurz, warum eine Demoverlängerung benötigt wird.").setSeverity('error');
        return;
      }
      this.busy.set(true);
      const companyId = this.company().id;
      this.api.sendRequest(ExtendDemoRequest, {
        companyId,
        feedback
      }).subscribe(response => {
        this.handleExtensionInquiryResponse(response);
      });
    }
    refreshStatus() {
      this.busy.set(true);
      const companyId = this.company().id;
      this.api.sendRequest(CheckDemoExtensionStatusRequest, {
        companyId
      }).subscribe(response => {
        this.busy.set(false);
        if (response.status === DemoExtensionStatus.Pending) {
          this.viewOverride.set('extension-pending');
          this.msg.createAndDisplay('Ihre Anfrage wurde noch nicht bearbeitet.').setSeverity('info');
        } else {
          this.refreshSession().subscribe(() => {
            if (response.status === DemoExtensionStatus.Rejected) {
              this.viewOverride.set('extension-rejected');
            } else {
              this.viewOverride.set('extension-granted');
            }
          });
        }
      });
    }
    handleExtensionInquiryResponse(response) {
      this.busy.set(false);
      if (response.status === DemoExtensionStatus.Granted) {
        this.refreshSession().subscribe(() => {
          const link = this.resolver.resolveRouterLink('frontend', 'management');
          this.router.navigate(link);
          this.msg.create("Ihre Demo wurde erfolgreich verlängert.").setSeverity('success');
        });
      } else if (response.status === DemoExtensionStatus.Pending) {
        this.viewOverride.set('extension-pending');
      } else {
        this.viewOverride.set('extension-rejected');
      }
    }
    static {
      this.ɵfac = function UsersDemoStartOverlayComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UsersDemoStartOverlayComponent)(i0.ɵɵdirectiveInject(i1.AppRequestService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.AccessFacade), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.RouterLinkResolverService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UsersDemoStartOverlayComponent,
        selectors: [["users-demo-start"]],
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 1,
        vars: 1,
        consts: [["defaultView", ""], [1, "overlay"], [1, "infobox"], ["theme", "content-soft", 1, "ui-margin"], ["position", "contact-members", 3, "context"], ["uiButton", "", "label", "zur\u00FCck", 1, "ui-button-grey", 3, "click"], [1, "ui-margin", 3, "ngModelChange", "ngModel"], ["uiButton", "", "label", "Verl\u00E4ngerung beantragen", 3, "click", "loading"], [4, "replaceableComponent"], ["uiButton", "", "label", "Status abfragen", 3, "click", "loading"], ["uiButton", "", "label", "Jetzt Kunde werden", "icon", "check", 3, "click"], ["uiButton", "", "label", "weiter zum Management-Bereich", "icon", "arrow-right", 3, "click"], [1, "infotext"], [1, "ui-margin-top-remove"], ["icon", "info-circle"], [1, "ui-margin"], ["uiButton", "", "label", "Demo um 14 Tage verl\u00E4ngern", "icon", "sync-alt", 1, "ui-button-grey", 3, "loading"], ["uiButton", "", "label", "Demoverl\u00E4ngerung beantragen", "icon", "sync-alt", 1, "ui-button-grey", 3, "loading"], ["uiButton", "", "label", "Demo um 14 Tage verl\u00E4ngern", "icon", "sync-alt", 1, "ui-button-grey", 3, "click", "loading"], ["uiButton", "", "label", "Demoverl\u00E4ngerung beantragen", "icon", "sync-alt", 1, "ui-button-grey", 3, "click", "loading"]],
        template: function UsersDemoStartOverlayComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UsersDemoStartOverlayComponent_Conditional_0_Template, 3, 1);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.status()) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [ReactiveFormsModule, i5.NgControlStatus, FormsModule, i5.NgModel, MinimalUiModule, i6.UiIconComponent, i7.UiCardComponent, i8.UiButtonComponent, UiInputGroupComponent, UiInputTextareaComponent, AppMessagesComponent, CmsModulePositionComponent, ReplaceableComponentDirective],
        styles: [".overlay[_ngcontent-%COMP%]{position:fixed;inset:0;z-index:9998;background:var(--invertedOverlaySoftColor);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);transition:background-color .3s}.overlay[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.infobox[_ngcontent-%COMP%]{background:var(--contentColor);color:var(--textColor);padding:20px;width:600px;max-width:90%;max-height:90%;overflow:auto;position:relative}.infotext[_ngcontent-%COMP%]{margin:0 0 30px}"]
      });
    }
  }
  return UsersDemoStartOverlayComponent;
})();